import { createInertiaApp, router } from '@inertiajs/svelte'
import { mount } from 'svelte'
import { initializeCable } from '../stores/cable'
import { initializeAnalytics } from '../analytics'
import {
  beforePageNavigation,
  finishPageNavigation,
  resolvePage,
} from '../pages'

router.on('before', beforePageNavigation)
router.on('finish', finishPageNavigation)

createInertiaApp({
  progress: false,

  resolve: resolvePage,

  setup({ el, App, props }) {
    if (el) {
      mount(App, { target: el, props })
      initializeAnalytics(props.initialPage)

      // Initialize ActionCable connection if user is logged in
      if (props.initialPage.props.current_user) {
        initializeCable()

        const currentUser = props.initialPage.props.current_user as {
          id?: unknown
        }
        const booklist = props.initialPage.props.booklist_data as
          { id?: unknown } | undefined
        if (Number.isSafeInteger(currentUser.id)) {
          const initialize = () => {
            void import('../offline/index')
              .then(({ initializeOfflineBookLists }) =>
                initializeOfflineBookLists({
                  ownerId: currentUser.id as number,
                  currentListId: Number.isSafeInteger(booklist?.id)
                    ? (booklist?.id as number)
                    : undefined,
                })
              )
              .catch(() => {
                // Offline preparation is optional and never blocks the app.
              })
          }
          // Mount and paint the normal Inertia page first, then load this
          // optional feature in a separate task and bundle.
          setTimeout(initialize, 0)
        }
      }
    } else {
      console.error(
        'Missing root element.\n\n' +
          'If you see this error, it probably means you load Inertia.js on non-Inertia pages.\n' +
          'Consider moving <%= vite_javascript_tag "inertia" %> to the Inertia-specific layout instead.'
      )
    }
  },

  defaults: {
    form: {
      forceIndicesArrayFormatInFormData: false,
    },
  },
})
